function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.50138 20C9.73404 20 10.7426 19.0769 10.7426 17.9487H6.26019C6.26019 18.4928 6.49631 19.0145 6.91662 19.3992C7.33692 19.7839 7.90698 20 8.50138 20ZM15.225 13.8462V8.71795C15.225 5.56923 13.3872 2.93333 10.1823 2.2359V1.53846C10.1823 0.68718 9.43148 0 8.50138 0C7.57129 0 6.82049 0.68718 6.82049 1.53846V2.2359C3.60437 2.93333 1.7778 5.55897 1.7778 8.71795V13.8462L0.332231 15.1692C-0.373744 15.8154 0.119318 16.9231 1.11665 16.9231H15.8749C16.8722 16.9231 17.3765 15.8154 16.6705 15.1692L15.225 13.8462Z",
  fill: "currentColor"
});

function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.0f01c249.svg";
export { ForwardRef as ReactComponent };